import {graphql, useLazyLoadQuery} from 'react-relay'

import {usePermission} from '../../../../hooks/usePermission'
import {Permission} from '../../../../types'

import type {usePermissionCanEditPipelineGetParentProjectIdQuery} from './__generated__/usePermissionCanEditPipelineGetParentProjectIdQuery.graphql'
import {usePipelineId} from './pipeline'

const query = graphql`
  query usePermissionCanEditPipelineGetParentProjectIdQuery($pipelineLocator: String!) {
    pipeline(pipelineLocator: $pipelineLocator) {
      parentProject {
        id
      }
    }
  }
`

function usePermissionCanEditPipeline() {
  const pipelineId = usePipelineId()
  const {pipeline} = useLazyLoadQuery<usePermissionCanEditPipelineGetParentProjectIdQuery>(query, {
    pipelineLocator: `id:${pipelineId}`,
  })

  const canEditPipeline = usePermission(Permission.EDIT_PROJECT, pipeline?.parentProject?.id)
  const canViewPipelineSettings = usePermission(
    Permission.VIEW_BUILD_CONFIGURATION_SETTINGS,
    pipeline?.parentProject?.id,
  )

  return {
    canEditPipeline,
    canViewPipelineSettings,
  }
}

export default usePermissionCanEditPipeline
